module.exports = __webpack_public_path__ + "static/img/system-2.faec2656.png";